import type React from "react";
import { useCrmPermission } from "../../../hooks/useCrmPermission";
import { ContractTab } from "../SalesBoardPage/components/ContractTab";

/**
 * 契約管理ページ
 * @return {React.ReactElement} 契約管理ページ
 */
const ContractPage: React.FC = () => {
  const { canManageContracts } = useCrmPermission();

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">契約管理</h1>
      <ContractTab canManageContracts={canManageContracts} />
    </div>
  );
};

export default ContractPage;
